function fadeCarousel(parent) {
  if ($('.fade-carousel').length == 0) return;
  parent.querySelectorAll('.fade-carousel').forEach(function (carousel) {
    var tl = gsap.timeline({
      repeat: -1,
      paused: true,
    });
    var items = carousel.querySelectorAll('li');
    var wrap = gsap.utils.wrap(Array.from(items));
    var pauseDuration = 3;
    items.forEach(function (item, index) {
      tl.fromTo(wrap(index), { autoAlpha: 1 }, { autoAlpha: 0 }, `+=${pauseDuration}`).fromTo(
        wrap(index + 1),
        { autoAlpha: 0 },
        { autoAlpha: 1 },
        '<+=0.5'
      );
    });
    tl.progress(1).play();
  });
}

window.fadeCarousel = fadeCarousel;
fadeCarousel(document);
